import { useState } from "react";
import api, { apiError } from "../lib/api";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Modal } from "../pages/OfficerHome";

export default function ChangePasswordModal({ onClose }) {
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (nw.length < 6) { toast.error("Password baru minimal 6 karakter"); return; }
    if (nw !== confirm) { toast.error("Konfirmasi password tidak cocok"); return; }
    setLoading(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: nw });
      toast.success("Password berhasil diubah");
      onClose();
    } catch (e) { toast.error(apiError(e)); } finally { setLoading(false); }
  };

  return (
    <Modal title="Ganti Password" onClose={onClose} testid="change-password-modal">
      <div className="space-y-3">
        <div><label className="label">Password Lama</label><input data-testid="cp-current" type="password" className="nnx-input mt-1" value={cur} onChange={(e) => setCur(e.target.value)} /></div>
        <div><label className="label">Password Baru</label><input data-testid="cp-new" type="password" className="nnx-input mt-1" value={nw} onChange={(e) => setNw(e.target.value)} placeholder="min. 6 karakter" /></div>
        <div><label className="label">Konfirmasi Password Baru</label><input data-testid="cp-confirm" type="password" className="nnx-input mt-1" value={confirm} onChange={(e) => setConfirm(e.target.value)} /></div>
      </div>
      <button className="btn-gold w-full mt-4" data-testid="cp-submit" onClick={submit} disabled={loading}>{loading ? <Loader2 className="h-4 w-4 animate-spin inline" /> : "SIMPAN PASSWORD"}</button>
    </Modal>
  );
}
